<template>
  <tr :class="cls">
    <td class="at-eg-cell-a">
      <div :class="cellUsernameClass">
        <p>{{user.name}}</p>
      </div>
    </td>
    <td class="at-eg-cell-a-b">
    </td>
    <td class="at-eg-cell-b"
        v-for="(date, idx) in dates"
        :key= 'idx' 
        :data-date="date" 
        :class="'at-eg-cell-' + idx">
      <div class="at-eg-tgroup" :class="'at-eg-tall-' + tallSize">
        <div v-for="(obj, idx1) in tasks" :key= 'idx1'>
          <task-item 
            :task="task" 
            :floor-index="idx1" 
            v-if="task = obj[date]"></task-item>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import TaskItem from './ganntTaskItem.vue'

  export default {
    components: {
      TaskItem
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      dates: {
        type: Array,
        required: true
      },
      tasks: {
        type: Array,
        required: true
      },
      total: {
        type: Number,
        default: 0
      },
      cls: {
        type: String
      }
    },
    created() {
    },
    computed: {
      tallSize () {
        return this.tasks.length;
      },
      taskCount() {
        return this.tasks.total;
      },
      cellUsernameClass() {
        if (this.total) {
          if (this.total != 1) {
            return 'at-eg-username x' + this.total.toString().trim();
          }
        }
        return 'at-eg-username';
      }
    },
  }
</script>

<style>
</style>
